import { Component } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { Session, States } from '../services/index';

@Component({
    selector: 'signup-address',
    templateUrl: 'signup-address.html'
})
export class SignupAddress {
  addressFormGroup: FormGroup;
  stateList = [];
      
  constructor(private fb: FormBuilder,
              private router: Router,
              public session: Session,
              private states: States) {  
    this.addressFormGroup = this.fb.group({
        'address1': new FormControl(this.session.patient.profile.address1, Validators.required),
        'address2': new FormControl(this.session.patient.profile.address2),
        'city': new FormControl(this.session.patient.profile.city, Validators.required),
        'state': new FormControl(this.session.patient.profile.state, Validators.required),
        'zipCode': new FormControl(this.session.patient.profile.zipCode, [Validators.required, Validators.minLength(5)])
    });

    let stateList = this.states.getStates();
    stateList.subscribe(response => {
      this.stateList = response;
    })
  }
     
  get address1() { return this.addressFormGroup.get('address1'); }
  get address2() { return this.addressFormGroup.get('address2'); }
  get city() { return this.addressFormGroup.get('city'); }
  get state() { return this.addressFormGroup.get('state'); }
  get zipCode() { return this.addressFormGroup.get('zipCode'); }

  continue() {
    this.router.navigate(['/signup-password' ]);
  }
}